import React, {useContext, useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {AuthContext} from "../../config/AuthContext";
import {useNavigate, useParams} from "react-router-dom";
import NavBar from "../components/NavBar";
import Login from "../root/Login";
import {Button, Card, Popconfirm, Table, Tabs } from "antd";
import Colors from "../../styles/Colors";
import {BiPencil, BiPlus, BiRefresh, BiTrash, BiUserPlus } from "react-icons/bi";
import Historials from "../components/Historials";
import {ColumnsType, TableProps} from "antd/es/table";
import {BsEye} from "react-icons/bs";
import PlantillaLista from "../PlantillaLista";
import RebutFIltre from "../../model/multilleure/rebuts/RebutFIltre";
import {Dayjs} from 'dayjs';
import toast, {Toaster} from "react-hot-toast";
import {QuestionCircleOutlined} from "@ant-design/icons";
import { User } from '../../model/root/User';
import {GetUsuaris} from "../../dao/root/GetUsuaris";
import EmpresaModal from "../admin/components/EmpresaModal";
import DuplicarModal from './components/DuplicarModal';
import {GetEmpresas} from '../../dao/admin/GetEmpresas';

const { TabPane } = Tabs;

const Admin = () => {
    const titol: string = "Panell administrador";
    const nomPermis: string = "Admin";

    const {isLoggedIn, userId, user, page} = useContext(AuthContext);
    const navigate = useNavigate();
    const {id} = useParams();

    const [coleccio, setDades] = useState<any[]>([]);
    const [elementSelected, setElementSelected] = useState<any>({});
    const [loading, setLoading] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [duplicarElement, setDuplicarElement] = useState(false);
    const [editar, setEditar] = useState(false);
    const [visible, setVisible] = useState(true);
    const [nomFiltres, setNomFiltres] = useState<{ text: string; value: string }[]>([]);
    const [tipusFiltres, setTipusFiltres] = useState<{ text: string; value: string }[]>([]);

    const permisosEdicio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 1);
    const permisVisualitzacio = user.pagines.some(pagina => pagina.descripcio === nomPermis && pagina.tipus === 0);



    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true)
            checkDades();
        }
    }, [id]);

     async function checkDades() {
        const dadesEmpresas = await GetEmpresas(1,page); //TODO Cambiar por id_parent
        setDades(dadesEmpresas);
        setLoading(true);
            
      
    }

    function toggleTable() {
        setVisible(!visible);
    }



    function editarElement(element: any) {
        checkDades();
        setElementSelected(element);
        setNouElement(!nouElement); 
       
    }


    function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");
        setNouElement(false);
        setDuplicarElement(false);
    }
    

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };
    

    if (isLoggedIn) {
        return (
            <div>
                <Toaster/>
                <NavBar/>
                <div className={"general"}>
                    
                        <div className={"actionButtons"}>
                            
                        </div>
                        <h4 className={"titol"} onClick={toggleTable}>{titol}</h4>
                       
                        <div className="flex-container">
                            {coleccio.map(value =>
                                <div className={`container ${value.logoClass}`}
                                    key={value.id} onClick={() => editarElement(value)}>
                                    {/* <div className="titolHome">{value.nomEmpresa}</div> */}
                                </div>
                            )}
                        </div>
                    
                    <br/>
                    {nouElement && (
                        <EmpresaModal element={elementSelected} onClose={handleCloseModal} visible={nouElement}/>

                    )}
                    
                </div>
            </div>
        );
    } else {
        return (
            <Login/>
        );
    }
};
export default Admin;
